import { Component } from "react";
import { Modal } from "react-bootstrap";
import ApiServices from "../../utils/apiServices";
import { v4 as uuidv4 } from 'uuid';
import { LocationOrigin } from '../../utils/utilityServices';
import { Authentication } from "../../utils/authenticationUtilityServices";
import axios from 'axios';
import Dropzone from 'react-dropzone';
import AlertMessagePopUpModal from "../GenAIPopUp/AlertMessagePopUpModal";
import { imsLoader, GenAiDOCIcon, GenAiPPTIcon, } from "../../assets";
import NoteBookPosterPrompt from "./NoteBookPosterPrompt";
import {
    UserData
} from "../../auth/Authorization";
import NoteBookProjectService from "../../services/NoteBookProjectSevice";

let _timeoutTime = (1000 * (300));
var _threadGuid = uuidv4();
let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
const api = new NoteBookProjectService();


export class CreateNBGenAIModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPasteText: false,
            selectOption: [],
            noteBookName: '',
            documentSelected: false,
            errorAlertMessage: '',
            isProcessing: false,
            sessionID: uuidv4(),
            focusDropDownCollapsed: false,
            attachedFilePopupCollapsed: false,
            commandType: '',
            attachedFiles: [],
            removedAttachedFileIndex: -1,
            alertMessageContent: '',
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            spinnerMessage: '',
            allFileContent: '',
            selectedProjectType: {},
            isProceed: false,
            prompts: '',
            noteBookNameError: '',
            newThreadID: '',
            projectTitle: '',
            textFile: '',
        }
    }
    async componentDidMount() {
        let services = new ApiServices();
        let res = await services.getAllProjectName();
        this.setState({ selectOption: res })
    }
    handleProjectType = (val) => {
        this.setState({ selectedProjectType: val })
    }
    dispalyProjectType = () => {
        let { selectOption, selectedProjectType } = this.state
        return (
            selectOption.filter( (x , index) => index < 3).map((val) => {
                return (
                    <>
                        <div class={(val.id !== selectedProjectType.id) ? "notebook-genai-pt-option-outline-primary" : "notebook-genai-pt-option-outline-primary selected-opt"}
                            onClick={() => { this.handleProjectType(val) }}>
                            <div class="notebook-grenai-pt-option-text" style={{ color: (val.id === selectedProjectType.id) && '#FFF' }}>
                                {val.project_type_name}</div>
                        </div>
                    </>
                )
            })
        )
    }
    onBlurNoteBookName = (e) => {
        this.setState({ projectTitle: e.target.value })
    }
    setNoteBookName = (e) => {
        this.setState({ noteBookName: e.target.value })
    }
    async fileInputChange(event) {
        const files = event;
        let { attachedFiles } = this.state;
        let isImageUpload = (Object.keys(files).some(x =>
            files[x].name.toLowerCase().endsWith('.gif')
            || files[x].name.toLowerCase().endsWith('.jpeg')
            || files[x].name.toLowerCase().endsWith('.jpg')
            || files[x].name.toLowerCase().endsWith('.png')))
            || (attachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.gif')
                || x.name.toLowerCase().endsWith('.jpeg')
                || x.name.toLowerCase().endsWith('.jpg')
                || x.name.toLowerCase().endsWith('.png')));

        let isDocUpload = (Object.keys(files).some(x =>
            files[x].name.toLowerCase().endsWith('.pdf')
            || files[x].name.toLowerCase().endsWith('.doc')
            || files[x].name.toLowerCase().endsWith('.docx')
            || files[x].name.toLowerCase().endsWith('.ppt')
            || files[x].name.toLowerCase().endsWith('.pptx')))
            || (attachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.pdf')
                || x.name.toLowerCase().endsWith('.doc')
                || x.name.toLowerCase().endsWith('.docx')
                || x.name.toLowerCase().endsWith('.ppt')
                || x.name.toLowerCase().endsWith('.pptx')))
        let isExcel = Object.keys(files).some(x => files[x].name.toLowerCase().endsWith('.xls')) ||
            attachedFiles.some(x => x.name.toLowerCase().endsWith('.xls'))

        if ((attachedFiles.length + Object.keys(files).length) > 5) {
            this.errorAlertMessage("You can only upload a maximum of 5 files");
        } else if (isExcel) {
            this.errorAlertMessage("You can only upload .doc,.docx,.ppt,.pptx,.pdf file only");
        } else if (isImageUpload && isDocUpload) {
            this.errorAlertMessage("You can upload either image file or document file");
        } else if (isImageUpload && (attachedFiles.length + Object.keys(files).length) > 1) {
            this.errorAlertMessage("You can only upload a maximum of 1 image file");
        } else {
            let _attachedFiles = [];
            let isUploadSuccessfully = true;
            for (var i = 0; i < Object.keys(files).length; i++) {
                let file = files[i];
                if (file.name.toLowerCase().endsWith('.pdf')
                    || file.name.toLowerCase().endsWith('.jpg')
                    || file.name.toLowerCase().endsWith('.jpeg')
                    || file.name.toLowerCase().endsWith('.png')
                    || file.name.toLowerCase().endsWith('.gif')) {
                    file.guid = uuidv4();
                    file.newFileName = file.name;
                    _attachedFiles.push(file);
                } else {
                    this.setState({ isProcessing: true, spinnerMessage: "Please wait while uploading the document.", attachedFilePopupCollapsed: false });
                    let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/PDFMaker`;
                    if (file.name.toLowerCase().endsWith('.doc') || file.name.toLowerCase().endsWith('.docx')) {
                        API_ENDPOINT += "?fileType=Document"
                    } else {
                        API_ENDPOINT += "?fileType=Presentation"
                    }
                    const formData = new FormData();
                    formData.append('form_filed_name', file)
                    const _headers = {
                        'content-type': 'multipart/form-data'
                    }
                    if (await Authentication.isAccessTokenAvailable()) {
                        const token = await Authentication.getAccessToken();
                        _headers.Authorization = `Bearer ${token}`;
                    }
                    try {
                        const res = await axios.post(API_ENDPOINT, formData, {
                            headers: _headers,
                            responseType: "blob",
                        });
                        let newFileName = file.name.split('.').slice(0, -1).join('.');
                        const fileName = `${newFileName}.pdf`;
                        const data = new Blob([res.data], { type: 'application/pdf' });
                        var newFile = new File([data], file.name, { type: 'application/pdf' });
                        newFile.guid = uuidv4();
                        newFile.newFileName = fileName;
                        _attachedFiles.push(newFile);
                    } catch (error) {
                        console.log(error);
                        isUploadSuccessfully = false;
                    }
                }
                if (!isUploadSuccessfully) {
                    break;
                }
            }
            if (!isUploadSuccessfully) {
                this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1, isProcessing: false }, () => {
                    this.errorAlertMessage("Upload failed due to some reason. Kindly try after some time.");
                });
            } else {
                var threadGuid = uuidv4();
                this.setState({ newAttachedFiles: _attachedFiles, newThreadID: threadGuid, spinnerMessage: "Please wait while uploading the document." }, async () => {
                    await this.handleSaveInS3();
                });
            }
        }
    }
    handleSaveInS3 = async (e) => {
        this.setState({ isProcessing: true });
        let { attachedFiles, sessionID, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        var url = `${_locationOrigin}/api/NotebookService/S3File/Upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}/api/NotebookService/S3File/Upload`
        }
        //var url = `https://localhost:44306/api/NotebookService/S3File/Upload`;
        const formData = new FormData();
        attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).forEach((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).length);
        formData.append(`sessionID`, sessionID);
        formData.append(`threadID`, newThreadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, false);

        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                this.multipleFilesUpload(e)
            } else if (!response.FileUpload && response.Files && response.Files.length === 0) {
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                this.setState({ updateAnyFile: true, newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false, isProcessing: false, spinnerMessage: '' }, () => {
                    //this.manageFilePlaceHolder();
                });
            }
            else if (!response.FileUpload && response.Files && response.Files.length > 0) {
                let failedGuid = response.Files.map(x => x.Guid)
                let finalFaileAttached = attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => failedGuid.includes(x.guid));
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${finalFaileAttached.map(x => x.name).join("<br /> - ")}`)
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !failedGuid.includes(x.guid)),
                    newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false, isProcessing: false, spinnerMessage: ''
                }, () => {
                    //this.manageFilePlaceHolder();
                });
            }
        }).catch((error) => {
            let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
            this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1, isProcessing: false, spinnerMessage: '' }, () => {
                if (isRemoveFile) {
                    this.errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
                } else {
                    this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                }
            });

            console.log(error)
        }).finally(() => {

        });

    }
    multipleFilesUpload = async (e) => {
        this.setState({ isProcessing: true, focusDropDownCollapsed: false, attachedFilePopupCollapsed: false });
        let { attachedFiles, sessionID, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        //let LocationOrigin = 'https://predev-ims.jnj.com';
        var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        }
        const formData = new FormData();
        attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).forEach((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).length);
        formData.append(`sessionID`, sessionID);
        formData.append(`threadID`, newThreadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, false);
        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
                let isSingleFile = newAttachedFiles.length === 1;
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex), newAttachedFiles: [], removedAttachedFileIndex: -1, threadID: newThreadID, selectedFilters: [], renderfilters: [], isComprehensive: false,
                    isFromSideBar: false, orignalText: '', commandText: ''
                }, async () => {
                    //this.manageFilePlaceHolder();
                    if (isRemoveFile) {
                        this.successAlertMessage("Document removed successfully.");
                    } else {
                        this.successAlertMessage(isSingleFile ? `Document uploaded successfully.` : `Documents uploaded successfully.`);
                    }
                });
            } else if (!response.FileUpload && response.Files && response.Files.length === 0) {
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                this.setState({ updateAnyFile: true, newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false, }, async () => {
                    //this.manageFilePlaceHolder();
                    //await this.context.updateSessionId(sessionID);
                });
            }
            else if (!response.FileUpload && response.Files && response.Files.length > 0) {
                let failedGuid = response.Files.map(x => x.Guid)
                let finalFaileAttached = attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => failedGuid.includes(x.guid));
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${finalFaileAttached.map(x => x.name).join("<br /> - ")}`)
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !failedGuid.includes(x.guid)),
                    newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false,
                }, async () => {
                    //this.manageFilePlaceHolder();
                    //await this.context.updateSessionId(sessionID);
                });
            }
            // this.setState({ updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex), newAttachedFiles: [], removedAttachedFileIndex: -1, threadID: newThreadID, chatHistory: [] }, async () => {
            //     this.manageFilePlaceHolder();
            //     await this.context.updateSessionId(sessionID);
            // });

        }).catch((error) => {
            let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
            this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1 }, () => {
                if (isRemoveFile) {
                    this.errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
                } else {
                    this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                }
            });

            console.log(error)
        }).finally(() => {
            this.setState({ isProcessing: false, spinnerMessage: '', commandType: 'QnA' });
        });
    }
    onDropAccepted = async (filestoUpload) => {
        this.fileInputChange(filestoUpload)
    }
    onDropRejected = (filestoUpload) => {
        if (filestoUpload.length > 5) {
            this.errorAlertMessage("You can only upload a maximum of 5 files");
        }
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    handleValidation = async (noteBookName) => {
        let services = new ApiServices();
        let response = await services.getAllGenAINoteBooKData(UserData.sub)
        let existingNoteBookName = response.map(x => x.notebook_name);
        let noteBookNameVal = noteBookName.trim().replace(/\s/g, "");
        if (noteBookNameVal.length === 0 || noteBookNameVal.length > 100 || existingNoteBookName.includes(noteBookName)) {
            if (noteBookNameVal < 1) {
                this.setState({ noteBookNameError: '**Please enter a notebook name to proceed.' })
            } else if (noteBookNameVal.length > 100) {
                this.setState({ noteBookNameError: '**NoteBook name exceed the limit' })
            } else if (existingNoteBookName.includes(noteBookName)) {
                this.setState({ noteBookNameError: '**NoteBook Name Already Exist' })
            }
            return false
        } else {
            return true
        }

    }
    handleCreate = async () => {
        const { attachedFiles, sessionID, noteBookName, selectedProjectType, isProceed, prompts, textFile } = this.state;
        let isValid = await this.handleValidation(noteBookName)
        if (isValid && (attachedFiles.length > 0 || textFile.length !== 0)) {
            this.setState({ noteBookNameError: '' })
            if (this.state.selectedProjectType.project_type_name !== "Plain Language Summary Poster" || isProceed) {
                this.props.handleCreateNew(attachedFiles, sessionID, noteBookName, selectedProjectType, _threadGuid, prompts, textFile);
                this.setState({ showPop: false, isProceed: false }, () => {
                    this.props.handleClose(false);
                });
            } else {
                this.setState({ isProceed: true })
            }
        } else if (attachedFiles.length < 1 && textFile.length === 0) {
            this.errorAlertMessage('Please select a file or source text to proceed')
        }
    }
    handleRemoveAttachedFile = async (index) => {
        let { attachedFiles } = this.state;
        attachedFiles = attachedFiles.filter((file, fileIndex) => fileIndex !== index);
        if (attachedFiles.length > 0) {
            var threadGuid = uuidv4();
            this.setState({ removedAttachedFileIndex: index, newThreadID: threadGuid }, async () => {
                await this.handleSaveInS3();
            });
        } else {
            this.setState({
                uploadFilePlaceHolder: "",
                uploadFilePlaceHolderTitle: "",
                attachedFiles: [],
                isAttachedFile: false,
                attachedFilePopupCollapsed: false,
                newAttachedFiles: [],
                removedAttachedFileIndex: -1,
                updateAnyFile: false,
            }, async () => {
                let { sessionID } = this.state;
                await this.handleSaveInS3();
                await api.deleteIndexBySessionId(sessionID);
                this.successAlertMessage("Document removed successfully.");
            })
        }
    }
    convertbytesToMB = (kb, decimals = 2) => {
        if (kb === 0) return '0 MB';
        const mb = kb / (1024 ** 2);
        // Use toFixed() to control the number of decimal places
        return `${mb.toFixed(decimals)} MB`;
    };

    renderFileIcon = (name) => {
        if (name.toLowerCase().endsWith('.pdf')) {
            return (<> <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="-4 0 40 40" fill="none">

                <g id="SVGRepo_bgCarrier" stroke-width="0" />

                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

                <g id="SVGRepo_iconCarrier"> <path d="M25.6686 26.0962C25.1812 26.2401 24.4656 26.2563 23.6984 26.145C22.875 26.0256 22.0351 25.7739 21.2096 25.403C22.6817 25.1888 23.8237 25.2548 24.8005 25.6009C25.0319 25.6829 25.412 25.9021 25.6686 26.0962ZM17.4552 24.7459C17.3953 24.7622 17.3363 24.7776 17.2776 24.7939C16.8815 24.9017 16.4961 25.0069 16.1247 25.1005L15.6239 25.2275C14.6165 25.4824 13.5865 25.7428 12.5692 26.0529C12.9558 25.1206 13.315 24.178 13.6667 23.2564C13.9271 22.5742 14.193 21.8773 14.468 21.1894C14.6075 21.4198 14.7531 21.6503 14.9046 21.8814C15.5948 22.9326 16.4624 23.9045 17.4552 24.7459ZM14.8927 14.2326C14.958 15.383 14.7098 16.4897 14.3457 17.5514C13.8972 16.2386 13.6882 14.7889 14.2489 13.6185C14.3927 13.3185 14.5105 13.1581 14.5869 13.0744C14.7049 13.2566 14.8601 13.6642 14.8927 14.2326ZM9.63347 28.8054C9.38148 29.2562 9.12426 29.6782 8.86063 30.0767C8.22442 31.0355 7.18393 32.0621 6.64941 32.0621C6.59681 32.0621 6.53316 32.0536 6.44015 31.9554C6.38028 31.8926 6.37069 31.8476 6.37359 31.7862C6.39161 31.4337 6.85867 30.8059 7.53527 30.2238C8.14939 29.6957 8.84352 29.2262 9.63347 28.8054ZM27.3706 26.1461C27.2889 24.9719 25.3123 24.2186 25.2928 24.2116C24.5287 23.9407 23.6986 23.8091 22.7552 23.8091C21.7453 23.8091 20.6565 23.9552 19.2582 24.2819C18.014 23.3999 16.9392 22.2957 16.1362 21.0733C15.7816 20.5332 15.4628 19.9941 15.1849 19.4675C15.8633 17.8454 16.4742 16.1013 16.3632 14.1479C16.2737 12.5816 15.5674 11.5295 14.6069 11.5295C13.948 11.5295 13.3807 12.0175 12.9194 12.9813C12.0965 14.6987 12.3128 16.8962 13.562 19.5184C13.1121 20.5751 12.6941 21.6706 12.2895 22.7311C11.7861 24.0498 11.2674 25.4103 10.6828 26.7045C9.04334 27.3532 7.69648 28.1399 6.57402 29.1057C5.8387 29.7373 4.95223 30.7028 4.90163 31.7107C4.87693 32.1854 5.03969 32.6207 5.37044 32.9695C5.72183 33.3398 6.16329 33.5348 6.6487 33.5354C8.25189 33.5354 9.79489 31.3327 10.0876 30.8909C10.6767 30.0029 11.2281 29.0124 11.7684 27.8699C13.1292 27.3781 14.5794 27.011 15.985 26.6562L16.4884 26.5283C16.8668 26.4321 17.2601 26.3257 17.6635 26.2153C18.0904 26.0999 18.5296 25.9802 18.976 25.8665C20.4193 26.7844 21.9714 27.3831 23.4851 27.6028C24.7601 27.7883 25.8924 27.6807 26.6589 27.2811C27.3486 26.9219 27.3866 26.3676 27.3706 26.1461ZM30.4755 36.2428C30.4755 38.3932 28.5802 38.5258 28.1978 38.5301H3.74486C1.60224 38.5301 1.47322 36.6218 1.46913 36.2428L1.46884 3.75642C1.46884 1.6039 3.36763 1.4734 3.74457 1.46908H20.263L20.2718 1.4778V7.92396C20.2718 9.21763 21.0539 11.6669 24.0158 11.6669H30.4203L30.4753 11.7218L30.4755 36.2428ZM28.9572 10.1976H24.0169C21.8749 10.1976 21.7453 8.29969 21.7424 7.92417V2.95307L28.9572 10.1976ZM31.9447 36.2428V11.1157L21.7424 0.871022V0.823357H21.6936L20.8742 0H3.74491C2.44954 0 0 0.785336 0 3.75711V36.2435C0 37.5427 0.782956 40 3.74491 40H28.2001C29.4952 39.9997 31.9447 39.2143 31.9447 36.2428Z" fill="#EB5757" /> </g>

            </svg></>)
        }
        else if (name.toLowerCase().endsWith('.doc') || name.toLowerCase().endsWith('.docx')) {
            return (<><img height={36} width={36} src={GenAiDOCIcon} alt="" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.ppt') || name.toLowerCase().endsWith('.pptx')) {
            return (<><img height={36} width={36} src={GenAiPPTIcon} alt="" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.jpg')
            || name.toLowerCase().endsWith('.jpeg')
            || name.toLowerCase().endsWith('.png')
            || name.toLowerCase().endsWith('.gif')) {
            return (<><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="miter">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5" stroke-width="0" fill="#059cf7" opacity="0.1"></polygon>
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5"></polygon>
                    <rect x="2" y="2" width="20" height="20" rx="0"></rect>
                    <line x1="6.99" y1="7" x2="7" y2="7" stroke-linecap="round" stroke-width="2"></line>
                </g>
            </svg> &nbsp;</>)
        }
        else {
            return (<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" class="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>)
        }
    }
    handlePasteText = (e) => {
        this.setState({ textFile: e.target.value })
        if (e.target.value.length > 0) {
            this.setState({ isPasteText: true })
        } else {
            this.setState({ isPasteText: false })
        }
    }
    render() {
        const { alertMessageShowModal, alertMessageContent, alertMessageModelColor, projectTitle, spinnerMessage, isProceed } = this.state
        return (<Modal
            show={this.props.showModal}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName="create-modal-popup"
            scrollable={true}
        >
            <div className="create-note-book-popup" style={{ /*overflow: "auto",*/ maxHeight: '91vh' }}>
                <Modal.Header
                    className="gsfModalHeader"
                    style={{ justifyContent: "left", background: '#FFFF', width: '100%' }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                        }}
                    >
                        <Modal.Title>
                            <div className="Note-Book-header">
                                <div className="create-modal-title">{projectTitle ? <>{projectTitle}</> : <>New Project</>}</div>
                                <div className="Note-Book-header-close"
                                    onClick={(e) => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </Modal.Title>
                    </div>
                </Modal.Header>
                {(this.state.selectedProjectType.project_type_name !== "Plain Language Summary Poster" || !isProceed) && <Modal.Body scrollable={true} className="create-notebook-genai-body">

                    <div class="notebook-genai-form-field">
                        <label for="notebookName" class="notebook-genai-form-label">Notebook Name</label>

                        <div class="notebook-genai-input-row">
                            <input
                                id="notebookName"
                                name="notebookName"
                                type="text"
                                class="notebook-genai-text-input"
                                placeholder="Untitled_Notebook"
                                maxlength="100"
                                aria-describedby="notebook-help notebook-error"
                                aria-invalid="false"
                                value={this.state.noteBookName}
                                onChange={this.setNoteBookName}
                                onBlur={this.onBlurNoteBookName}
                            />
                        </div>

                        <div className="notebook-genai-notebook-help">{(this.state.noteBookNameError.length > 0) ? `${this.state.noteBookNameError}` : "Name with a maximum of 100 characters."}</div>
                        <div id="notebook-genai-notebook-error" class="error-text" aria-live="polite" hidden>
                            Name cannot exceed 100 characters.
                        </div>
                    </div>
                    <div className="notebook-genai-source-con">
                        <div className="notebook-genai-title-con">
                            <span className="notebook-genai-title">Add Sources</span>
                        </div>
                        <div className="notebook-genai-browser">
                            {(this.state.attachedFiles.length === 0) && <div class="notebook-genai-root-add-sources" role="region" aria-label="File upload area">
                                <Dropzone onDrop={acceptedFiles => { }}
                                    autoFocus={true}
                                    onDropRejected={this.onDropRejected}
                                    onDropAccepted={this.onDropAccepted}
                                    onError={this.onDropError}
                                    noClick={false}
                                    maxFiles={5}

                                >
                                    {({ getRootProps, getInputProps, isDragActive }) => (
                                        <section style={{ padding: '0' }} className="container">

                                            <div style={{ display: 'flex', cursor: 'pointer' }}{...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <div class="notebook-genai-inner">
                                                    <div class="notebook-genai-icon-wrap" aria-hidden="true">
                                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H12M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.5 21L17.5 15M17.5 15L20 17.5M17.5 15L15 17.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        </g></svg>
                                                    </div>
                                                    <div class="notebook-genai-text">Drag and Drop Files here or</div>
                                                    <div class="notebook-genai-actions">

                                                        <span class="notebook-genai-button">
                                                            <label for="pdfUploadFile" style={{ cursor: "pointer" }}>Browse Files</label>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>)}
                                </Dropzone>

                                <div class="notebook-genai-footer" aria-hidden="false">
                                    <div class="notebook-genai-info">Please upload .doc,.docx,.ppt,.pptx,.pdf file only</div>
                                    <div class="notebook-genai-info">Maximum limit 50 MB</div>
                                </div>
                            </div>}
                            {(this.state.attachedFiles.length > 0) && <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {this.state.attachedFiles.map((x, index) =>
                                    <div className="sources-ele">
                                        <span>
                                            {this.renderFileIcon(x.name)}
                                        </span>
                                        <div className='sources-ele-inner'>
                                            <div className="sources-ele-label">{x.name}</div>
                                            <div className="sources-ele-label" style={{ marginTop: '5px', fontWeight: '300' }}>{this.convertbytesToMB(x.size)}</div>
                                        </div>
                                        <span style={{cursor:"pointer"}} title="Delete" onClick={() => this.handleRemoveAttachedFile(index)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M4.75 0.75H8.75M0.75 2.75H12.75M11.4167 2.75L10.9491 9.76286C10.879 10.815 10.8439 11.3411 10.6167 11.74C10.4166 12.0912 10.1148 12.3735 9.75111 12.5498C9.33798 12.75 8.81073 12.75 7.75623 12.75H5.74377C4.68927 12.75 4.16202 12.75 3.74889 12.5498C3.38517 12.3735 3.08339 12.0912 2.88332 11.74C2.65607 11.3411 2.621 10.815 2.55086 9.76286L2.08333 2.75M5.41667 5.75V9.08333M8.08333 5.75V9.08333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span>

                                    </div>)}
                            </div>}
                        </div>
                        <div className={(this.state.isPasteText) ? 'notebook-genai-add-text ht-60' : "notebook-genai-add-text"}
                        >
                            {(!this.state.isPasteText) && <div class="notebook-genai-or-row" role="group" aria-label="Alternate input method">
                                <div class="notebook-genai-or-text">Or</div>

                                <button type="button" class="notebook-genai-text-button" onClick={() => { this.setState({ isPasteText: true }) }}>
                                    Paste Text
                                </button>

                                <div class="notebook-genai-or-text">Here.</div>
                            </div>}
                            {(this.state.isPasteText) && <textarea style={{ width: "100%", border: "none", background: '#F9F8F7', padding: '4px 8px' }} placeholder="Paste your text here."
                                onChange={(e) => this.handlePasteText(e)}
                                value={this.state.textFile}></textarea>}
                        </div>
                    </div>
                    <div class="notebook-grenai-container-project-type">
                        <div class="notebook-grenai-pt-label-row">
                            <div class="label-text-notebook-grenai-pt">Choose Project Type</div>
                        </div>
                        <div class="notebook-grenai-pt-option-wrap">
                            {/*<div class="notebook-genai-pt-option-outline-primary">
                                <div class="notebook-grenai-pt-option-text">Draft New Content</div>
                            </div>*/}
                            {this.dispalyProjectType()}
                        </div>
                    </div>
                </Modal.Body>}
                {this.state.selectedProjectType.project_type_name === "Plain Language Summary Poster" && isProceed && <Modal.Body scrollable={true} style={{ width: "100%", height: "100%" }}>
                    <div className="source-conc">
                        <label className="addSource-text">Notebook Name :</label>
                        <span className="addSource-text fw-400">{this.state.noteBookName.length > 0 ? this.state.noteBookName : 'Untitled Notebook'}</span>
                    </div>
                    {<div className="source-conc" style={{ gap :'15px'}}>
                        {this.state.attachedFiles.length > 0 && <><label className="addSource-text">Added Sources :</label>
                        <div>{this.state.attachedFiles.map((x, index) => <div className="addSources-item">
                            <span className="addSource-text fw-400">
                                {x.name}</span>
                        </div>)}</div></>}
                        {this.state.textFile && <>
                            <label className="addSource-text">Added Source Text:</label>
                            <span className="addSource-text fw-400 text-box-plain">
                                {this.state.textFile}</span>
                        </>}
                    </div>}
                    <NoteBookPosterPrompt
                        selectedProjectType={this.state.selectedProjectType}
                        handleClose={() => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                        }}
                        handlePrompt={(prompts) => {
                            this.setState({ prompts: prompts }, () => {
                                if (prompts.length > 0) {
                                    this.handleCreate();
                                } else {
                                    this.errorAlertMessage('Please select at least one prompt to proceed.')
                                }
                            });
                        }} />
                </Modal.Body>}
                {(this.state.selectedProjectType.project_type_name !== "Plain Language Summary Poster" || !isProceed) && <Modal.Footer style={{ border: "none", width: '100%' }}>
                    <div className={"notebook-genai-cc"} onClick={this.handleCreate}
                        style={{
                            background: ((this.state.attachedFiles.length > 0 || this.state.textFile.length !== 0) && this.state.noteBookNameError.trim().length === 0 ? '#EB1700' : ''),
                            color: ((this.state.attachedFiles.length > 0 || this.state.textFile.length !== 0) && this.state.noteBookNameError.trim().length === 0 ? '#FFFF' : '')
                        }}>Proceed</div>
                    <div className={"notebook-genai-cc"}
                        onClick={(e) => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                        }}>Cancel</div>
                </Modal.Footer>}
                {this.state.isProcessing &&
                    <Modal
                        show={this.state.isProcessing}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="savePopUp"
                        className="gen-ai-answering-search-spinner-popup"
                        backdropClassName="z-index-gen-ai-answering-search-spinner-popup"
                        scrollable={true}>
                        <div style={{ padding: "0 5%" }}>
                            <div style={{ fontSize: "14px", textAlign: "center" }}>
                                <Modal.Body>
                                    <img src={imsLoader} alt="" width={100} height={100} />
                                    <div className="saveModal-heading" style={{ color: "#EB1700" }}>{spinnerMessage ? spinnerMessage : `Please wait.`} </div>
                                </Modal.Body>
                            </div>
                        </div>
                    </Modal>}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
            </div>
        </Modal>

        )
    }
}